/*eslint default-case: 0*/
import produce from 'immer';
import * as actionTypes from '../actions/actionTypes';
import initialState from './initialState';

export const uiReducer = ( state = initialState.ui, action ) =>
    produce(state, draft => {
        switch (action.type) {
            case actionTypes.SET_CURRENCY:
                draft.currency = action.payload;
                return;
            case actionTypes.SET_APP_LOADED:
                draft.appLoaded = action.payload;
                return;
            case actionTypes.UI_REGION_CHANGED: {
                draft.region = action.payload;
                return;
            }
        }
    });
